export const setToken = (token: string) => localStorage.setItem('token', token);
export const getToken = () => {
  const token = localStorage.getItem('token');
  // adding token to cookie if not present
  if (token) {
    document.cookie = `token=${token}; max-age=2592000; path=/`;
  }
  return token;
};

export const removeToken = () => localStorage.removeItem('token');

export const setGleapUserHash = (gleapUserHash: string) =>
  localStorage.setItem('gleapUserHash', gleapUserHash);

export const getGleapUserHash = () => localStorage.getItem('gleapUserHash');

export const removeGleapUserHash = () =>
  localStorage.removeItem('gleapUserHash');

export const setGleapAnonymousUserId = (gleapAnonymousUserId: string) =>
  localStorage.setItem('gleapAnonymousUserId', gleapAnonymousUserId);

export const getGleapAnonymousUserId = () =>
  localStorage.getItem('gleapAnonymousUserId');

export const removeGleapAnonymousUserId = () =>
  localStorage.removeItem('gleapAnonymousUserId');

/**
 * Dedicated key for the device-scoped anonymous Gleap hash.
 * Kept separately from gleapUserHash so the session hash (set after login)
 * never overwrites it, and it is never deleted on logout.
 */
export const setGleapAnonymousUserHash = (hash: string) =>
  localStorage.setItem('gleapAnonymousUserHash', hash);

export const getGleapAnonymousUserHash = () =>
  localStorage.getItem('gleapAnonymousUserHash');

export const setDemoAccountToken = (demoAccountToken: string) => {
  sessionStorage.setItem('demoAccountToken', demoAccountToken);
};

export const getDemoAccountToken = () => {
  const demoAccountToken = sessionStorage.getItem('demoAccountToken');
  return demoAccountToken;
};

export const removeDemoAccountToken = () => {
  sessionStorage.removeItem('demoAccountToken');
};

export const getCurrentToken = () => {
  const demoAccountToken = getDemoAccountToken();

  if (demoAccountToken) {
    return demoAccountToken;
  }

  const token = getToken();
  return token;
};
